import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IMarcas } from '../interfaces/Marcas';
import { IEdificios } from '../interfaces/Edificios';
import Swal from 'sweetalert2';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IUsuarios } from '../interfaces/Usuarios';
import { Alert } from 'selenium-webdriver';


@Component({
  selector: 'app-maestro-usuario-add',
  templateUrl: './maestro-usuario-add.component.html',
  styleUrls: ['./maestro-usuario-add.component.css']
})
export class MaestroUsuarioAddComponent implements OnInit {
  addForm: FormGroup;
  marcas: IMarcas[];
  edificios: IEdificios[];
  tipoUsuario = [];


  constructor(private router: Router,
    private registroServicios: RegistroVentasService,
    private formBuilder: FormBuilder) { }


  ngOnInit(): void {
    this.cargarFormularioAdd();
    this.cargaEdificios();
    this.cargaMarcas();
    this.obtenerTipoUsuario();
  }

  cargaEdificios() {
    this.registroServicios.obtenerEdificios().subscribe(
      resolve => {
        if (resolve != null) {
          this.edificios = resolve;
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'No se cargaron los edificios...',
            text: 'Valide con el administrador.'
          })
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  cargaMarcas() {
    this.registroServicios.obtenerMarcas().subscribe(
      resolve => {
        if (resolve != null) {
          this.marcas = resolve;
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'No se cargaron los marcas...',
            text: 'Valide con el administrador.'
          })
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  cargarFormularioAdd() {
    this.addForm = this.formBuilder.group({
      identificacion: ['', Validators.required],
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      email:['', [Validators.required, Validators.nullValidator]],
      edificiosAutorizados: [''],
      marcasAutorizadas: [''],
      tipoUsuario: ['', Validators.required],
      clave: ['', Validators.required],
      cargo: [''],
      celular: ['', Validators.required]
    });
  }

  get f() { return this.addForm.controls; }

  onSubmit() {


        if (this.addForm.invalid) {
          return;
        }

    var strEdificios = this.addForm.controls['edificiosAutorizados'].value
    this.addForm.controls['edificiosAutorizados'] =  strEdificios.length != 0 ? strEdificios.join(",") : "";

    var strMarcas = this.addForm.controls['marcasAutorizadas'].value
    this.addForm.controls['marcasAutorizadas'] =strMarcas.length != 0 ? strMarcas.join(",") : "";

    const formulario: IUsuarios = {
      ...this.addForm.value,
      SubscripciónId:2,
      edificiosAutorizados: this.addForm.controls['edificiosAutorizados'],
      marcasAutorizadas: this.addForm.controls['marcasAutorizadas']
    };

    this.registroServicios.crearUsuario(formulario)
      .subscribe(data => {
        this.goBack();
      });
    }

  goBack() {
    this.router.navigate(['/home/registro/AdmUsuario']);
  }

  public onSelectAll() {
    const selected = this.edificios.map(item => item.codigo);
    this.addForm.get('edificiosAutorizados').patchValue(selected);
  }

  public onClearAll() {
    this.addForm.get('edificiosAutorizados').patchValue([]);
  }

  public onSelectAllMarcas() {
    const selected = this.marcas.map(item => item.codigo);
    this.addForm.get('marcasAutorizadas').patchValue(selected);
  }

  public onClearAllMarcas() {
    this.addForm.get('marcasAutorizadas').patchValue([]);
  }

  obtenerTipoUsuario() {
    this.tipoUsuario = [
      { codigo: 'ReporteMarca,Pactia', nombre: 'Pactia' },
      { codigo: 'ReporteMarca,Marca', nombre: 'Marca' },
      { codigo: 'ReporteMarca,MarcaCertificada', nombre: 'Marca venta certificada' },
      { codigo: 'ReporteMarca,Marca,MarcaCertificada', nombre: 'Marca y Marca venta certificada' },
      { codigo: 'ReporteMarca,Administrador', nombre: 'Administrador' },
      { codigo: 'ReporteMarca,AdministradorCertificadas', nombre: 'Administrador ventas certificadas' }
    ];
  }

}
